import Api from "../../Api";

export const getFlag = async (flagName) => {
  try {
    const res = await Api.get(`/internal/flags/${flagName}`);
    return res?.data ?? { enabled: false };
  } catch {
    return { enabled: false };
  }
};
